// Why an email didn't go out, in words that say what to do. The codes come
// from the server's SMTP sender (server/src/email/smtp.ts, smtp-config.ts).

export const SMTP_REASON: Record<string, string> = {
  'no-smtp-host': 'no mail server is configured (SMTP_HOST on the server)',
  'bad-smtp-port': 'SMTP_PORT on the server is not a valid port',
  'incomplete-smtp-auth': 'the server has SMTP_USER or SMTP_PASS but not both',
  'no-from-address': 'no sender address is configured (Admin → System → Email, or SMTP_FROM_EMAIL)',
  'smtp-auth-failed': 'the mail server refused the SMTP login — check SMTP_USER / SMTP_PASS',
  'send-failed': 'the mail server rejected it or could not be reached — check the address and the server log',
};
